import { Component } from '@angular/core';
import { Footer } from "../../shared/footer/footer";
import { AlwaysThere } from "../../shared/always-there/always-there";
import { InterestYou } from "../../shared/interest-you/interest-you";
import { Navbar } from "../../shared/navbar/navbar";
import { SmallFaq } from "../../shared/small-faq/small-faq";
import { Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { Inject, PLATFORM_ID } from '@angular/core';
import { Title } from '@angular/platform-browser';
@Component({
  selector: 'app-contact',
  imports: [SmallFaq, Footer, Navbar, AlwaysThere, InterestYou],
  templateUrl: './contact.html',
  styleUrl: './contact.css',
})
export class Contact {

    constructor(@Inject(PLATFORM_ID) private platformId: Object,private router: Router,private titleService: Title) {
    this.titleService.setTitle('YouPrice. | Mentions légales');
  }
 ngOnInit(): void {

    if (isPlatformBrowser(this.platformId)) {
      (window as any).dataLayer = (window as any).dataLayer || [];
      (window as any).dataLayer.push({ 
        event: 'virtual_page_view',
        ecommerce: null,
        page_location: 'https://www.youprice.fr/',
        page_path: '/',
        content_group: 'HP',
        user_id: ''
      });
    }
  }

goToFaq(){
    this.router.navigate(['/faq']);
  }
}
